import { render } from "./market-chart.vue?vue&type=template&id=f3fb0572"
import script from "./market-chart.vue?vue&type=script&lang=js"
export * from "./market-chart.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__